import { Types } from './types'

const initialState = {
    dataJob: {
        rows: [],
        paging: {}
    },
    dataTag: [],
    dataAllTag: []
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_JOB:
            return {
                ...newState,
                dataPost: action.payload
            }
        case Types.SAVE_LIST_TAG_JOB:
            return {
                ...newState,
                dataTag: action.payload
            }
        case Types.SAVE_ALL_TAG_JOB:
            return {
                ...newState,
                dataAllTag: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
